import type { ReactElement } from 'react';
import { getFontFamily } from '@/theme/typography';
import { getMindmapCompactPreviewModel, } from './mindmap-compact-preview-model';
import type { ParsedMindmap } from './mindmap-types';
import { MindmapCompactPreviewChildRow } from './MindmapCompactPreviewChildRow';
import { MindmapCompactPreviewOverflowRow } from './MindmapCompactPreviewOverflowRow';
import { dataEl, type DataElScope } from '@/utils/dataEl';
export function MindmapCompactPreview({ dataElScope, parsed, }: {
    dataElScope: DataElScope;
    parsed: ParsedMindmap | null;
}): ReactElement {
    const previewModel = getMindmapCompactPreviewModel(parsed);
    return (
      <div data-el={dataEl(dataElScope, 'MindmapCompactPreview/Root')} style={{
            position: 'absolute',
            inset: 0,
            padding: '6px 12px 32px',
            display: 'flex',
            flexDirection: 'column',
            gap: 6,
            justifyContent: 'center',
            overflow: 'hidden',
        }}>
        <div data-el={dataEl(dataElScope, 'MindmapCompactPreview/Header')} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 7,
            fontFamily: getFontFamily(),
            fontSize: 12,
            fontWeight: 700,
            letterSpacing: '0.01em',
            color: '#66FEC1',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            paddingBottom: 2,
            borderBottom: '1px solid rgba(102,254,193,0.2)',
        }}>
          <span style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            backgroundColor: '#66FEC1',
            boxShadow: '0 0 8px #66FEC1',
            flexShrink: 0,
        }}/>
          <span style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        }}>
            {previewModel.rootLabel}
          </span>
        </div>
        {previewModel.childRows.map((childRow) => {
            return (<MindmapCompactPreviewChildRow dataElScope={dataElScope} key={childRow.key} isLast={childRow.isLast} label={childRow.label}/>);
        })}
        {previewModel.overflowCount > 0 ? (<MindmapCompactPreviewOverflowRow dataElScope={dataElScope} overflowCount={previewModel.overflowCount}/>) : null}
      </div>
    );
}
